import React, { useEffect, useState } from 'react';
import './CpaStateDropdown.scss';
import PropTypes from 'prop-types';
import { Select } from '@thd-olt-component-react/select';
import { notEmptyRegex } from '@thd-olt-functional/utils';
import { validate } from '../../constants/constants';

const CpaStateDropdown = (props) => {

  const { callback, header, selected, name } = props;

  const [prefillText, setPrefillText] = useState('Select');

  const formattedHeader = <span>{header}<span style={{ color: 'red' }}>*</span></span>;

  useEffect(() => {
    if (name === 'stateOfResidence' && selected === '') {
      setPrefillText('Select State');
    } else {
      setPrefillText(selected);
    }
  });

  let states = [{
    name: '',
    value: ''
  },
  {
    name: 'Alabama',
    value: 'Alabama'
  },
  {
    name: 'Alaska',
    value: 'Alaska'
  },
  {
    name: 'American Samoa',
    value: 'American Samoa'
  },
  {
    name: 'Arizona',
    value: 'Arizona'
  },
  {
    name: 'Arkansas',
    value: 'Arkansas'
  },
  {
    name: 'Armed Forces America',
    value: 'Armed Forces America'
  },
  {
    name: 'Armed Forces Europe',
    value: 'Armed Forces Europe'
  },
  {
    name: 'Armed Forces Pacific',
    value: 'Armed Forces Pacific'
  },
  {
    name: 'California',
    value: 'California'
  },
  {
    name: 'Colorado',
    value: 'Colorado'
  },
  {
    name: 'Connecticut',
    value: 'Connecticut'
  },
  {
    name: 'Delaware',
    value: 'Delaware'
  },
  {
    name: 'District of Columbia',
    value: 'District of Columbia'
  },
  {
    name: 'Florida',
    value: 'Florida'
  },
  {
    name: 'Georgia',
    value: 'Georgia'
  },
  {
    name: 'Guam',
    value: 'Guam'
  },
  {
    name: 'Hawaii',
    value: 'Hawaii'
  },
  {
    name: 'Idaho',
    value: 'Idaho'
  },
  {
    name: 'Illinois',
    value: 'Illinois'
  },
  {
    name: 'Indiana',
    value: 'Indiana'
  },
  {
    name: 'Iowa',
    value: 'Iowa'
  },
  {
    name: 'Kansas',
    value: 'Kansas'
  },
  {
    name: 'Kentucky',
    value: 'Kentucky'
  },
  {
    name: 'Louisiana',
    value: 'Louisiana'
  },
  {
    name: 'Maine',
    value: 'Maine'
  },
  {
    name: 'Marshall Islands',
    value: 'Marshall Islands'
  },
  {
    name: 'Maryland',
    value: 'Maryland'
  },
  {
    name: 'Massachusetts',
    value: 'Massachusetts'
  },
  {
    name: 'Michigan',
    value: 'Michigan'
  },
  {
    name: 'Minnesota',
    value: 'Minnesota'
  },
  {
    name: 'Mississippi',
    value: 'Mississippi'
  },
  {
    name: 'Missouri',
    value: 'Missouri'
  },
  {
    name: 'Montana',
    value: 'Montana'
  },
  {
    name: 'Nebraska',
    value: 'Nebraska'
  },
  {
    name: 'Nevada',
    value: 'Nevada'
  },
  {
    name: 'New Hampshire',
    value: 'New Hampshire'
  },
  {
    name: 'New Jersey',
    value: 'New Jersey'
  },
  {
    name: 'New Mexico',
    value: 'New Mexico'
  },
  {
    name: 'New York',
    value: 'New York'
  },
  {
    name: 'North Carolina',
    value: 'North Carolina'
  },
  {
    name: 'North Dakota',
    value: 'North Dakota'
  },
  {
    name: 'Northern Mariana Islands',
    value: 'Northern Mariana Islands'
  },
  {
    name: 'Ohio',
    value: 'Ohio'
  },
  {
    name: 'Oklahoma',
    value: 'Oklahoma'
  },
  {
    name: 'Oregon',
    value: 'Oregon'
  },
  {
    name: 'Palau',
    value: 'Palau'
  },
  {
    name: 'Pennsylvania',
    value: 'Pennsylvania'
  },
  {
    name: 'Puerto Rico',
    value: 'Puerto Rico'
  },
  {
    name: 'Rhode Island',
    value: 'Rhode Island'
  },
  {
    name: 'South Carolina',
    value: 'South Carolina'
  },
  {
    name: 'South Dakota',
    value: 'South Dakota'
  },
  {
    name: 'Tennessee',
    value: 'Tennessee'
  },
  {
    name: 'Texas',
    value: 'Texas'
  },
  {
    name: 'United States Outlying Islands',
    value: 'United States Outlying Islands'
  },
  {
    name: 'Utah',
    value: 'Utah'
  },
  {
    name: 'Vermont',
    value: 'Vermont'
  },
  {
    name: 'Virginia',
    value: 'Virginia'
  },
  {
    name: 'Virgin Islands, U.S.',
    value: 'Virgin Islands, U.S.'
  },
  {
    name: 'Washington',
    value: 'Washington'
  },
  {
    name: 'West Virginia',
    value: 'West Virginia'
  },
  {
    name: 'Wisconsin',
    value: 'Wisconsin'
  },
  {
    name: 'Wyoming',
    value: 'Wyoming'
  }];

  return (
    <div className="cpa-state-dropdown">
      <Select
        header={formattedHeader}
        selected={prefillText}
        options={states}
        onChange={(event) => {
          callback(event.target.value, name, validate(event.target.value, notEmptyRegex));
        }}
      />
    </div>
  );
};

CpaStateDropdown.propTypes = {
  callback: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  selected: PropTypes.string,
  name: PropTypes.string.isRequired
};

CpaStateDropdown.defaultProps = {
  selected: ''
};

CpaStateDropdown.displayName = 'CpaStateDropdown';

export { CpaStateDropdown };
